// Batch 5: before a quote is saved, ask the backend whether its value looks wrong
// (much bigger than the previous version, much bigger than before this edit, or over the
// limit). If it does, the user is asked "Please check this value" with "Save anyway" /
// "Go back".
//
// Every quote save goes through quotationRequest() in sendRequest.js, so the question is
// asked by one dialog mounted in App.vue (AnomalyConfirmDialog.vue), reached on the event
// bus. Never window.confirm: it freezes browser automation.
import EventBus from '@/event-bus'

export const ANOMALY_CONFIRM = 'quote-anomaly-confirm'

/**
 * Shows the warnings and resolves true for "Save anyway", false for "Go back". Never rejects.
 * With no dialog mounted (nothing took the request) it resolves true: the save goes ahead as
 * before, and the backend still logs the warning after the save.
 */
export function anomalyConfirm(that, warnings) {
  return new Promise(function (resolve) {
    var request = { warnings: warnings || [], taken: false, answer: function (ok) { resolve(ok === true) } }
    try {
      EventBus.$emit(ANOMALY_CONFIRM, request)
    } catch (e) {
      console.error('quote value check: the dialog failed', e)
    }
    if (!request.taken) resolve(true)
  })
}

/** The quoteAnomalyCheck body for a quote as about to be sent (opportunity already reduced to its id). */
export function anomalyCheckBody(quote) {
  var q = quote || {}
  var opp = q.opportunity && typeof q.opportunity === 'object' ? q.opportunity.oppId : q.opportunity
  var body = {
    oppId: opp === undefined || opp === null || opp === '' ? null : Number(opp),
    sQuoteNo: q.sQuoteNo || null,
    versionNo: q.versionNo === undefined || q.versionNo === null || q.versionNo === '' ? null : Number(q.versionNo),
    productValue: Number(q.productValue) || 0
  }
  if (q.quoteVerId) body.quoteVerId = q.quoteVerId
  return body
}

/**
 * Resolves true to go ahead with the save, false when the user chose "Go back". Never rejects.
 * When the user chose "Save anyway" the quote gets `anomalyConfirmed: true`. If the check
 * itself fails, the save goes ahead as it always did.
 */
export function checkBeforeQuoteSave(that, quote) {
  var check
  try {
    check = Promise.resolve(that.quotationService.quoteAnomalyCheck(anomalyCheckBody(quote)))
  } catch (e) {
    check = Promise.reject(e)
  }
  return check.then(
    function (result) {
      var warnings = result && Array.isArray(result.warnings) ? result.warnings : []
      if (!warnings.length) return true
      return anomalyConfirm(that, warnings).then(function (ok) {
        if (ok) quote.anomalyConfirmed = true
        return ok
      })
    },
    function (err) {
      console.error('quote value check failed; saving as usual', err)
      return true
    }
  )
}
